import Registration from './registrations'

export default Registration